import * as BABYLON from 'babylonjs';
import GuiManager from './babylonGui';
import { Probe, Dfy, Battery, Zhy } from './probe';
import {baseUrl} from '../url'
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
//const SecondURL = "https://localhost:3000";
//const SecondURL = "https://www.cdtracer.cn/cdut";
const SecondURL = (() => {
    const origin = window.location.origin;
    const segments = window.location.pathname.split('/').filter(Boolean);
    const secondSegment = segments.length > 0 ? `/${segments[0]}` : '';
    return `${origin}${secondSegment}`;
})();
const URL =baseUrl;
export default class Player{
    constructor(game, options = {}){
        this.id = uuidv4();
        //console.log(this.id);
        this.scene = game.scene;
        this.canvas = game.canvas;
        this.engine = game.engine;
        this.onResultImage = options.onResultImage;
        this.camera=null;
        this.FpsCamera=null;
        this.light=new BABYLON.DirectionalLight("dir01", new BABYLON.Vector3(-1, -2, -1), this.scene);
        this.guiManger=new GuiManager(game);
        this.ArcCamera();
        this.sign=[];
        this.isDrawed=false;
        this.isDrawing=false;
        this.isGenProbe=false;
        this.isGenRope=false;
        this.startpoint=BABYLON.Vector3.Zero();
        this.endpoint=BABYLON.Vector3.Zero();
        this.distance=0;
        this.Probe=[];
        this.rope=[];
        this.dfy=null;
        this.geomodel = null;
        this.probeDistance=0;
        this.testDeep = 0;
        this.colorSpheres=[];
        this.probeArrayPos=[];
        // this.obsever=this.scene.onBeforeRenderObservable.add(()=>{
        //     //this.light.position=this.camera.position;
        // });
        game.engine.isPointerLock=false;
        //this.showAxis(1000,this.scene)
    }
    destoryAll(){
        this.isDrawed=false;
        this.isGenProbe = false;
        this.isGenRope = false;
        this.guiManger.refreshDistanceUI(0);
        //this.Probe=this.destoryMeshs(this.Probe); 
        this.sign=this.destoryMeshs(this.sign); 
        this.rope=this.destoryMeshs(this.rope);
        if(this.Probe.length!=0){
            this.Probe=this.destoryMeshs(this.Probe);
        }
    }
    destoryMeshs(meshs){        
        if (meshs.length != 0) {
            meshs.forEach(item => {
                item.dispose();
                item = [];
            });
            //meshs=[];
            return [];
        }
        else {
            return [];
        }
        //console.log(meshs.length);
    }
    disposeObserver(){
        if(this.observer!=null){
            this.scene.onBeforeRenderObservable.remove(this.observer);
        }
        if(this.scene.onPointerObservable.hasObservers()){
            this.scene.onPointerObservable.remove(this.observer);
        }
    }
    disposeObservers(){
        if(this.scene.onBeforeRenderObservable.hasObservers()){
            //console.log("clear!")
            this.scene.onBeforeRenderObservable.clear();
        }
        if(this.scene.onPointerObservable.hasObservers()){
            this.scene.onPointerObservable.clear();
        }
    }
    vecToLocal(vector, mesh){
        mesh.computeWorldMatrix();  
        let m = mesh.getWorldMatrix();
        let v = BABYLON.Vector3.TransformCoordinates(vector, m);
        return v;		 
    }
    checkbottom(directionRay,deep,oriMesh){
        //console.log("hitting")
        let origin = oriMesh.position;
	
        //let forward = new BABYLON.Vector3(0,-1,0);
        let forward = directionRay;		
	    forward = this.vecToLocal(forward, oriMesh);
	
	    let direction = forward.subtract(origin);
	    direction = BABYLON.Vector3.Normalize(direction);
	
	    let length = deep;
	
	    let ray = new BABYLON.Ray(origin, direction, length);

        // let rayHelper = new BABYLON.RayHelper(ray);		
		// rayHelper.show(this.scene);	
        // let hit = this.scene.pickWithRay(ray, (mesh)=>{
        //     if (mesh == this.mesh || mesh.name=="indicator"){
        //         return false;
        //     }
        //     return true;
        // });
        let hit = this.scene.pickWithRay(ray);
        if (hit.pickedMesh){
            //oriMesh.position.y =directionRay.y<0?hit.pickedPoint.y+0.1:hit.pickedPoint.y-0.1;
            //return hit.pickedPoint.y;
            //oriMesh.position.y=hit.pickedPoint.y;
            //console.log("locate: "+hit.pickedPoint.y+";"+hit.pickedMesh.name);
            oriMesh.position.y =hit.pickedPoint.y;
        }
    }
    setray(vector,mesh){
        let origin = mesh.position;
        let upward = vector;		
        upward = this.vecToLocal(upward, mesh);
    
        let direction = upward.subtract(origin);
        direction = BABYLON.Vector3.Normalize(direction);
    
        let length = 1;
    
        let ray = new BABYLON.Ray(origin, direction, length);

        let hit = this.scene.pickWithRay(ray);
        /*****draw debug ray  ******/
        //let rayHelper = new BABYLON.RayHelper(ray);		
        //rayHelper.show(self.scene);
        /***************************/
        if(hit.hit){
            //console.log("ray:"+hit.pickedMesh.name);
            return true;
        } 
        return false;
    }
    ArcCamera(){
        //this.camera = new BABYLON.UniversalCamera("camera", new BABYLON.Vector3(0, 0, -10), this.scene);
        this.camera = new BABYLON.ArcRotateCamera("MainCamera", 3 * Math.PI / 2, 0.5, 20,  new BABYLON.Vector3(100,100,100), this.scene);
        // this.camera.angularSensibilityX=1000;
        // this.camera.angularSensibilityY=1000;
        // this.camera.minZ=1;
        //this.camera.maxZ=5000;
        //this.camera.speed=1000;
        // this.camera.upperBetaLimit=Math.PI/2;
        this.camera.wheelPrecision = 0.50;
        this.camera.lowerRadiusLimit=100;
        this.camera.upperRadiusLimit=3000;
        // //this.scene.activeCameras.push(this.camera);
        this.scene.activeCamera = this.camera;
        this.camera.attachControl(this.canvas, true); 
        this.camera.checkCollisions  = true;
        //setTimeout(()=>{this.camera.lowerRadiusLimit=2000;},1000);
        this.camera.panningSensibility=50;
        //this.guiManger.cameraFOVslider(this.camera);
    }
    myFpsCamera(target){
        
        //let cameraPrePosition=BABYLON.Vector3.Lerp(startpoint,endpoint,0.5);
        let cameraPrePosition=0;
        // if(this.Probe!=null){
        //     let vx=this.Probe[0].position.x;
        //     let vy=this.Probe[0].position.y;
        //     let vz=this.Probe[0].position.z;
        //     cameraPrePosition=new BABYLON.Vector3(vx,vy,vz);
        // }
        cameraPrePosition=new BABYLON.Vector3(target.x,target.y,target.z);
        this.camera.target=cameraPrePosition;
        setTimeout(()=>this.spinTo(this.camera,"radius", 1, 100), 1000);
        setTimeout(()=>this.spinTo(this.camera,"fov", 0.2, 100), 1000);
        this.camera.panningSensibility=50;
        this.camera.wheelPrecision = 0.9;
        this.camera.lowerRadiusLimit=10;
        this.camera.upperRadiusLimit=1000;
        //this.camera.target=BABYLON.Vector3.Lerp(startpoint,endpoint,0.5);
        //console.log("move to center,start: "+startpoint+",end: "+endpoint)//+" position: "+this.FpsPerson.position);
    }
    myCameraAinmation(pos,newTarget,lowerRadiusLimit,angle=0,detachControl=true){
        // let camera = new BABYLON.UniversalCamera("UniversalCamera", new BABYLON.Vector3(0, 3, -30),this.scene);
        // camera.position = this.camera.position;
        // camera.setTarget(newTarget);
        // this.camera = camera;
        // this.scene.activeCamera = this.camera;
        this.camera.checkCollisions = false;
        this.camera.lowerRadiusLimit=lowerRadiusLimit;
        this.camera.setTarget(newTarget);
        //console.log("angle"+angle);
        if(detachControl){
            this.camera.detachControl(this.canvas);
        }
        else{
            this.camera.attachControl(this.canvas,true);
        }

       // this.camera.attachControl(this.canvas,true);

        let frameRate = 20;

        let rotate = new BABYLON.Animation("rotate", "alpha", frameRate, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);
	
        let rotate_keys = []; 

        rotate_keys.push({
            frame: 0,
            value: 0
        });

        rotate_keys.push({
            frame: 3 * frameRate,
            value: 0
        });

        rotate_keys.push({
            frame: 4 * frameRate,
            value: angle
        });

        rotate.setKeys(rotate_keys);
        
        let movein = new BABYLON.Animation("movein", "position", frameRate, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);
        
        let movein_keys = []; 

        movein_keys.push({
            frame: 0,
            value: this.camera.position
        });

        movein_keys.push({
            frame: 3 * frameRate,
            value: pos
        });

        movein.setKeys(movein_keys);

        this.scene.beginDirectAnimation(this.camera, [movein,rotate], 0, 5 * frameRate, false);
        this.camera.checkCollisions = true;
        
    }
    spinTo(camera,whichprop, targetval, speed) {
        let ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
        BABYLON.Animation.CreateAndStartAnimation('at4', camera, whichprop, speed, 120, camera[whichprop], targetval, 0, ease);
    }
    //弃用
    drawline(dis){
        let flag=false;
        let modelshow =new BABYLON.MeshBuilder.CreateCylinder("indicator", { height: 100, diameterTop:100, diameterBottom: 0.5}, this.scene);
        let model = new BABYLON.MeshBuilder.CreateBox('indicator',{width:1,height:1,depth:1});
        let Material = new BABYLON.StandardMaterial("material", this.scene);
        Material.emissiveColor = new BABYLON.Color3(0, 0.58, 0.86);
        modelshow.material = Material;
        modelshow.position.y=50;
        modelshow.parent=model; 
        //model.isVisible=false;
        model.isPickable = false;
        modelshow.isPickable = false;
        //modelshow.isVisible = false;
        //modelshow.isVisible=true;
        let model2 = BABYLON.MeshBuilder.CreateCylinder("indicator", { height: 5, diameterTop: 0.5, diameterBottom: 0.5 }, this.scene);
        model2.isVisible=false;
        let model3 = BABYLON.MeshBuilder.CreateCylinder("indicator", { height: 5, diameterTop: 0.5, diameterBottom: 0.5 }, this.scene);
        model3.isVisible=false;
        let self=this;
        function onPointerMove(evt) {
            
            let pickInfo = self.scene.pick(self.scene.pointerX, self.scene.pointerY, (mesh)=> {                       
                return (mesh.name == 'geo')                                                
            }, false, self.camera);

            if (pickInfo.hit) {
                modelshow.isVisible=true;
                if (model) {
                    
                    model.position = pickInfo.pickedPoint;
                    model.position.y+=0.5;
                }
            }
                
        }
        function originray(mesh){
            let fore=new BABYLON.Vector3.Forward();
            let back=new BABYLON.Vector3.Backward();
            let left=new BABYLON.Vector3.Left();
            let right=new BABYLON.Vector3.Right();
            if(self.setray(fore,mesh)||self.setray(back,mesh)||self.setray(left,mesh)||self.setray(right,mesh)){
                //console.log("ray:",false);
                return false;
            }
            else return true;
        }
        this.scene.onPointerDown = function (evt, pickResult) {
            if(!model3.isVisible){
                // if the click hits the object, we change the impact position
                
                if (pickResult.hit  && originray(model)) {
                    if(model2.isVisible===false)
                    {
                        model2.isVisible=true;
                        model2.position=model.position;
                        model2.rotationQuaternion=model.rotationQuaternion;
                        self.startpoint=new BABYLON.Vector3(model2.position.x,model2.position.y,model2.position.z);
                        flag=true;

                        //let myPoints1 = model2.position;
                    }
                    else if(self.distance/dis>120){
                        alert("测线过长，电极数大于120！");
                    }
                    else{
                        //flag=true;
                        model3.isVisible=true;
                        model3.position=model.position;
                        model3.rotationQuaternion=model.rotationQuaternion;
                        flag=false;
                        self.isDrawed=true;
                        model.isVisible=false;
                        self.endpoint=new BABYLON.Vector3(model3.position.x,model3.position.y,model3.position.z);
                        //let distance=$("#drawline").attr("value");
                        //self.genernateProbe3(dis);
                        self.delayProbe(dis);
                        
                        //let myPoints2 = model3.position;
                    }

                    //flag=true;
                    //console.log(flag);
                }
            }
            
        }
        
        let myPoints=[new BABYLON.Vector3(model2.position.x,model2.position.y+0.5,model2.position.z),new BABYLON.Vector3(model.position.x,model.position.y+0.5,model.position.z)];
        // let reds = BABYLON.Color3.Red(); 
        //line
        let lines=BABYLON.MeshBuilder.CreateLines("lines", {points: myPoints,updatable:true}, this.scene); 
        lines.color = BABYLON.Color3.Red();
        this.canvas.addEventListener("pointermove", onPointerMove, false);
        
        this.scene.onBeforeRenderObservable.add(function(){
         
            if(model2.isVisible && flag){
                //draw line
                lines.enableEdgesRendering();	
                lines.edgesWidth = 100.0;
                myPoints=[new BABYLON.Vector3(model2.position.x,model2.position.y+0.5,model2.position.z),new BABYLON.Vector3(model.position.x,model.position.y+0.5,model.position.z)];
                lines = BABYLON.MeshBuilder.CreateLines("lines", {points: myPoints, instance: lines} );
                lines.color = BABYLON.Color3.Red();
                self.distance=parseFloat(BABYLON.Vector3.Distance(model2.position,model.position).toFixed(2));
                self.guiManger.refreshDistanceUI(self.distance);
            }            
        });
            
        this.canvas.addEventListener("pointermove", onPointerMove, false);

        this.scene.onDispose = function () {            
            self.canvas.removeEventListener("pointermove", onPointerMove);
        }
        modelshow.isVisible = false;
        this.sign.push(modelshow);
        this.sign.push(model);
        this.sign.push(model2);
        this.sign.push(model3);
        this.sign.push(lines);
    }
    originray(mesh){
        let fore=new BABYLON.Vector3.Forward();
        let back=new BABYLON.Vector3.Backward();
        let left=new BABYLON.Vector3.Left();
        let right=new BABYLON.Vector3.Right();
        if(this.setray(fore,mesh)||this.setray(back,mesh)||this.setray(left,mesh)||this.setray(right,mesh)){
            //console.log("ray:",false);
            return false;
        }
        else return true;
    }
    //画测线方法
    drawline2(dis){
        this.isDrawing = true;
        //用于检测方向
        let model = new BABYLON.MeshBuilder.CreateBox('indicator',{width:1,height:1,depth:1});
        //用于展示位置
        let modelshow =new BABYLON.MeshBuilder.CreateCylinder("indicator", { height: 100, diameterTop:100, diameterBottom: 0.5}, this.scene);
        let Material = new BABYLON.StandardMaterial("material", this.scene);
        Material.emissiveColor = new BABYLON.Color3(0, 0.58, 0.86);
        modelshow.material = Material;
        modelshow.position.y=50;
        modelshow.parent=model; 
        model.isPickable = false;
        modelshow.isPickable = false;

        //首尾电极
        let modelStart = BABYLON.MeshBuilder.CreateCylinder("indicator", { height: 5, diameterTop: 0.5, diameterBottom: 0.5 }, this.scene);
        modelStart.isVisible=false;
        let modelEnd = BABYLON.MeshBuilder.CreateCylinder("indicator", { height: 5, diameterTop: 0.5, diameterBottom: 0.5 }, this.scene);
        modelEnd.isVisible=false;

        //line follows mouse movemonet
        let targetStart=this.guiManger.initGuiTarget("guiLine","10px","10px","black","white");
        let targetEnd=this.guiManger.initGuiTarget("guiLine","10px","10px","black","white");
        let newline=this.guiManger.initGuiLine("guiTarget",0.5,5,"black");
        targetStart.isVisible=false;
        targetEnd.isVisible=false;
        newline.isVisible=false;

        this.sign.push(modelshow);
        this.sign.push(model);
        this.sign.push(modelStart);
        this.sign.push(modelEnd);
        this.sign.push(newline);
        this.sign.push(targetStart);
        this.sign.push(targetEnd);

        //完成放置第一个电极
        let flagS = false;
        //完成放置最后一个电极
        let flagE = false;
        //所有完成
        let allDone = false;

        let distance = "";
        
        this.observer=this.scene.onPointerObservable.add((pointerInfo) => {
             if(allDone){
                 return;
             }
             if(flagE){
                this.isDrawed=true;
                this.distance=parseFloat(BABYLON.Vector3.Distance(this.startpoint,this.endpoint).toFixed(2));
                this.guiManger.refreshDistanceUI(this.distance);
                this.delayProbe(dis);
                allDone = true;
                this.isDrawing = false;
             }
             let pickInfo = this.scene.pick(this.scene.pointerX, this.scene.pointerY, (mesh)=> {                       
                return (mesh.name === 'geo')                                                
            }, false, this.camera);
             
             switch (pointerInfo.type) {
                case BABYLON.PointerEventTypes.POINTERDOWN:
                outer:

                    if(pickInfo.hit && this.originray(model)){
                        if(flagS===false){
                            this.startpoint=new BABYLON.Vector3(pickInfo.pickedPoint.x,pickInfo.pickedPoint.y,pickInfo.pickedPoint.z);
                            modelStart.position = this.startpoint;
                            modelStart.isVisible = true;
                            targetStart.linkWithMesh(modelStart);
                            targetStart.isVisible = true;
                            newline.isVisible=true;
                            newline.connectedControl = targetStart;
                            flagS=true;
                        }
                        else{
                            this.endpoint=new BABYLON.Vector3(pickInfo.pickedPoint.x,pickInfo.pickedPoint.y,pickInfo.pickedPoint.z);
                            modelEnd.position = this.endpoint;
                            modelEnd.isVisible = true;
                            targetEnd.linkWithMesh(modelEnd);
                            targetEnd.isVisible = true;
                            newline.connectedControl = targetEnd;
                            modelshow.isVisible = false;
                            flagE = true;
                        }
                    }
                break;
                 
                case BABYLON.PointerEventTypes.POINTERMOVE:
                    if(pickInfo.hit){
                        model.position = pickInfo.pickedPoint;
                        model.position.y += 0.5;

                        newline.x1=this.scene.pointerX;
                        newline.y1=this.scene.pointerY;

                        if(flagS){
                            distance = parseFloat(BABYLON.Vector3.Distance(this.startpoint,pickInfo.pickedPoint).toFixed(2));
                            this.guiManger.refreshDistanceUI(distance);
                        }
                    }
                    
                   
                    //console.log("POINTER MOVE");
                    break;
             }
         });
    }
    //弃用
    genernateProbe2(probeDistance){
        let genernated=false;       
        let self=this;
        //let light2 = new BABYLON.DirectionalLight("DirectionalLight", new BABYLON.Vector3(0.5, -0.6, 0.3), this.scene);
        probeDistance=parseInt(probeDistance);
        //this.light.shadowMaxZ=200;
        //let shadowGenerator=new BABYLON.ShadowGenerator(1024, this.light);
        let spheregen=[];
        let numPoints=(self.distance / probeDistance)-1;
        //console.log(numPoints);
        numPoints=parseInt(numPoints);
        let step=1/(numPoints);
        //FIRST PROBE
        //spheregen[0]=new Probe(self.scene,5,self.startpoint,"probe"+0);
        spheregen[0]=BABYLON.Mesh.CreateBox("probe"+j, 5/10,this.scene);
        spheregen[0].scaling.y=5;
        spheregen[0].position=self.startpoint;
        self.Probe.push(spheregen[0]);  
        let j=1;
        //let dis=BABYLON.Vector3.Zero();
        //console.log(self.distance);
        for(let i=step;i<1+step;i+=step){
            let dis=BABYLON.Vector3.Lerp(self.startpoint,self.endpoint,i);
            spheregen[j]=new Probe(self.scene,5,dis,"probe"+j);
            self.Probe.push(spheregen[j]);           
            j+=1;
        }
        //END Probe
        // spheregen[j]=spheregen[0].createInstance("probe" + j);
        // spheregen[j].position=self.endpoint;
        // self.Probe.push(spheregen[j]);
        //shadowGenerator.addShadowCaster(spheregen[0]);
        //shadowGenerator.usePoissonSampling = true;
        genernated=true;
    }
    genernateProbe3(probeDistance){  
        let genernated=false;       
        let self=this;
        let height = Math.abs(self.startpoint.y - self.endpoint.y);
        //let light2 = new BABYLON.DirectionalLight("DirectionalLight", new BABYLON.Vector3(0.5, -0.6, 0.3), this.scene);
        probeDistance=parseInt(probeDistance);
        this.probeDistance = probeDistance;
        //this.light.shadowMaxZ=200;
        //let shadowGenerator=new BABYLON.ShadowGenerator(1024, this.light);
        let spheregen=[];
        let numPoints=(self.distance / probeDistance)-1;
        numPoints=parseInt(numPoints);
        //console.log("电极数量："+numPoints);
        
        let step=1/(numPoints);
        //FIRST PROBE
        //spheregen[0]=new Probe(self.scene,5,self.startpoint,"probe"+0);
        //spheregen[0]=BABYLON.MeshBuilder.CreateCylinder("probe"+0, { height: 5, diameterTop: 5/10, diameterBottom:5/10 }, this.scene);
        // BABYLON.SceneLoader.ImportMesh("", "assets/models/", "probe.glb", this.scene, 
        //     (result)=> {
        //         let mesh = BABYLON.Mesh.MergeMeshes(result[0].getChildMeshes());
        //         spheregen[0] = mesh;
                
        //     });
        
        spheregen[0]=BABYLON.Mesh.CreateBox("probe"+0, 1,this.scene);
        spheregen[0].scaling.y=15;
        spheregen[0].position=self.startpoint;
        spheregen[0].position.y+=5;
        spheregen[0].isPickable = false;
        self.Probe.push(spheregen[0]);  
        let j=1;
        //let dis=BABYLON.Vector3.Zero();
        //console.log(self.distance);
        for(let i=step;i<1+step;i+=step){
            let dis=BABYLON.Vector3.Lerp(self.startpoint,self.endpoint,i);
            // dis.y+=200;
            // spheregen[j]=new Probe(self.scene,5,dis,"probe"+j);
            //spheregen[j]=BABYLON.MeshBuilder.CreateCylinder("probe"+j, { height: 5, diameterTop: 5/10, diameterBottom:5/10 }, this.scene);
            spheregen[j] = spheregen[0].createInstance("probe"+j);
            // spheregen[j]=BABYLON.Mesh.CreateBox("probe"+j, 5/10, this.scene);
            // spheregen[j].scaling.y=10;
            spheregen[j].position = dis;
            spheregen[j].position.y += 200;
            spheregen[j].isPickable = false;
            //spheregen[j].parent = spheregen[0];
            self.Probe.push(spheregen[j]);  
            
            //spheregen[j].position = this.GetNearestPoint(spheregen[j],this.geomodel);
            
            j+=1;
        }
        let mat = new BABYLON.StandardMaterial("Probe", this.scene);
        mat.disableLighting = true;
        //mat.emissiveColor = BABYLON.Color3.Black();
        mat.emissiveColor = new BABYLON.Color3(255/255,79/255,41/255)
        spheregen[0].material = mat;
        for(let k=0;k<spheregen.length;k++){
            let tempposy = spheregen[k].position.y;
            this.checkbottom(new BABYLON.Vector3(0,-1,0),500,spheregen[k]);
            if(tempposy === spheregen[k].position.y)
            {
                //spheregen[k].position.y+=200;
                //console.log("check again");
                this.checkbottom(new BABYLON.Vector3(0,-1,0),1000,spheregen[k]);
            }
            //spheregen[k].position.y+=10;
            //console.log(k+" , "+spheregen[k].position.y);
        }
        this.isGenProbe = true;
        //this.engine.hideLoadingUI();
        //alert("计算完成，请生成测线");
        //return spheregen;
        //this.scene.freezeActiveMeshes(true);
        this.destoryMeshs(this.sign);
        this.genernateRope(spheregen)
    }
    genernateProbeModel(probeDistance){  
        BABYLON.SceneLoader.ImportMesh("", "assets/models/", "probe.glb", this.scene, (
            meshes, 
            particleSystems,
            skeletons,
            animationList
        )=> {
               
            let self=this;
            
            probeDistance=parseInt(probeDistance);
            this.probeDistance = probeDistance;
           
            let spheregen=[];
            let numPoints=(self.distance / probeDistance)-1;
            numPoints=parseInt(numPoints);
          
            let step=1/(numPoints);
            meshes[0].name = "probe0";
            let angle = Math.acos(BABYLON.Vector3.Dot((self.endpoint.subtract(self.startpoint)).normalize(),new BABYLON.Vector3(1,0,0)));
            console.log(angle);
            //meshes[0].rotation.y=angle;
            meshes[0].rotate(BABYLON.Axis.Y, angle, BABYLON.Space.WORLD);
            spheregen[0]=meshes[0];
            // spheregen[0].scaling.y=15;
           

            spheregen[0].position=self.startpoint;
            spheregen[0].position.y+=5;
            spheregen[0].isPickable = false;
            self.Probe.push(spheregen[0]);  
            let j=1;

            for(let i=step;i<1+step;i+=step){
                let dis=BABYLON.Vector3.Lerp(self.startpoint,self.endpoint,i);
                spheregen[j] = spheregen[0].clone("probe"+j);
    
                spheregen[j].position = dis;
                spheregen[j].position.y += 200;
                spheregen[j].isPickable = false;
                self.Probe.push(spheregen[j]);  
                j+=1;
            }
            // let mat = new BABYLON.StandardMaterial("Probe", this.scene);
            // mat.disableLighting = true;

            // mat.emissiveColor = new BABYLON.Color3(255/255,79/255,41/255)
            // spheregen[0].material = mat;
            for(let k=0;k<spheregen.length;k++){
                let tempposy = spheregen[k].position.y;
                this.checkbottom(new BABYLON.Vector3(0,-1,0),500,spheregen[k]);
                if(tempposy === spheregen[k].position.y)
                {
    
                    this.checkbottom(new BABYLON.Vector3(0,-1,0),1000,spheregen[k]);
                }
    
            }
            this.isGenProbe = true;
            this.destoryMeshs(this.sign);
            this.genernateRope(spheregen)

        });
  
    }
    delayProbe(probeDistance){
        let promise = new Promise((resolve, reject)=> {
            this.engine.displayLoadingUI();
            // 异步处理
            setTimeout(()=> {

                //this.genernateProbe3(probeDistance);　　
                this.genernateProbeModel(probeDistance);
                resolve("ok");
            }, 1000);
            // 处理结束后、调用resolve 或 reject

        });
        promise.then(()=>{
                this.engine.hideLoadingUI();
                alert("计算完成，请进入接线环节");
        })
        
    }
    GetNearestPoint(currentSphere,mesh) {
        let nearestMesh, nearestFacet, facetPos;
        let tmpVect = BABYLON.Vector3.Zero(); 
        let projected;
        let distance = 0;
        let facetNorm = 0; 
        let shortestDistance = 9999999;
        //meshes.forEach(function (mesh) {     // meshes is an array containing the mesh and its "sub meshes"
        mesh.computeWorldMatrix(true);
        mesh.updateFacetData();
        let facets = mesh.getFacetLocalPositions()
    
            if (facets.length > 0) {
                facets.forEach(function (facet) {
                    distance = BABYLON.Vector3.Distance(currentSphere.position, facet);
                    if (distance < shortestDistance) {
                        nearestFacet = facet;
                        shortestDistance = distance;
                        nearestMesh = mesh;
                    }
                });
            }
        //});
    
        projected = BABYLON.Vector3.Zero();
        facetNorm = BABYLON.Vector3.Zero();
        facetPos = BABYLON.Vector3.Zero();
        let index = nearestMesh.getClosestFacetAtCoordinates(nearestFacet.x, nearestFacet.y, nearestFacet.z, projected);
        if(index!=null){
           let worldPos = mesh.getFacetPosition(index);              // the world position of this facet
            // use the vector3 projected here ...
            //console.log(worldPos);
            currentSphere.position.y = worldPos.y;
            // mesh.getFacetNormalToRef(index, facetNorm);
            // mesh.getFacetPositionToRef(index, facetPos);
            // currentSphere.position = currentSphere.position.subtractToRef(projected, tmpVect);      
        }
        return projected.y;  // use this set of coordinates to construct the newer/closer sphere
    }
    genernateRope(spheregen){
        this.rope=[]
        let nbPoints = this.distance/10;
        let allPoints=[];
        let step=1/nbPoints;
        for(let j=0;j<spheregen.length-1;j++){
            let myPoints = [];
            for(let i=step;i<1;i+=step) {
                let newPos=BABYLON.Vector3.Lerp(spheregen[j].position,spheregen[j+1].position,i);
                //newPos.y+=2;
                newPos.y+=3.3;
                myPoints.push(newPos);
            }
            allPoints.push(myPoints);
        } 
        let linesystem = BABYLON.MeshBuilder.CreateLineSystem("linesystem", {lines: allPoints},this.scene);
        linesystem.color =new BABYLON.Color3(0,0,0);
        this.rope.push(linesystem); 
        allPoints=[];
    }

    genernateDFY(scene,pos){
        let dfy=new Dfy(scene,1,new BABYLON.Vector3(-6,0,0));
        let zhy=new Zhy(scene,1,new BABYLON.Vector3(6,0,0));
        let battery=new Battery(scene,1,new BABYLON.Vector3(-13,0,0));
        //battery.mesh.rotationQuaternion =new BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0,1,0),-Math.PI/2);
        let equitment=new BABYLON.MeshBuilder.CreateBox("equitment",{size:0.1},scene);
        equitment.isVisible=false;
        dfy.mesh.parent=equitment;
        zhy.mesh.parent=equitment;
        battery.mesh.parent=equitment;

        this.dfy=dfy;
        let newEquitmentpos = new BABYLON.Vector3(pos.x,pos.y+5,pos.z);
        let vec1 = this.startpoint.subtract(this.endpoint);
        let npos = new BABYLON.Vector3(pos.x,pos.y-10,pos.z);
        let vec2 = this.startpoint.subtract(npos);
        let cross = BABYLON.Vector3.Cross(vec1,vec2);
        cross = BABYLON.Vector3.Normalize(cross);
        equitment.position=newEquitmentpos;
        equitment.translate(cross,20);
        equitment.position.y+=200;
        this.checkbottom(new BABYLON.Vector3(0,-1,0),1000,equitment);
        equitment.position.y+=10;

        let newpos = new BABYLON.Vector3(equitment.position.x,equitment.position.y,equitment.position.z);

        //Camera
        let tempPos = new BABYLON.Vector3(newpos.x,newpos.y+50,newpos.z);
        let tempTarget = new BABYLON.Vector3(newpos.x,newpos.y,newpos.z);
        dfy.camPos=tempPos;
        dfy.camTarget=tempTarget
        dfy.screen.camPos = new BABYLON.Vector3(tempPos.x-5,tempPos.y-40,tempPos.z);
        dfy.screen.camTarget = new BABYLON.Vector3(tempTarget.x-5,tempTarget.y,tempTarget.z);
        //this.myFpsCamera(newpos);
        //this.myCameraAinmation(tempPos,tempTarget,10,-Math.PI/2,false);
        //this.camera.alpha=Math.PI/2*3;
        this.camera.panningSensibility=50;
        this.camera.wheelPrecision = 5;
        //this.camera.lowerRadiusLimit=500;
        this.camera.upperRadiusLimit=5000;

        let v1 = new BABYLON.Vector3(zhy.pa.position.x+newpos.x+zhy.mesh.position.x,zhy.pa.position.y+newpos.y+zhy.mesh.position.y,zhy.pa.position.z+newpos.z+zhy.mesh.position.z);
        let v0 =  new BABYLON.Vector3(this.startpoint.x,this.startpoint.y+5,this.startpoint.z);
        let tempvec0 = new BABYLON.Vector3(this.startpoint.x,this.startpoint.y+20,this.startpoint.z);
        let tempvec1 = new BABYLON.Vector3(v1.x,v1.y+0.5,v1.z);
        let myPoints1=[v0,tempvec0,tempvec1,v1];
        let line1=BABYLON.MeshBuilder.CreateLines("line1", {points: myPoints1}, this.scene); 
        line1.color=BABYLON.Color3.Black(); 
        if(this.Probe.length>=31){
            let v2 = new BABYLON.Vector3(zhy.pb.position.x+newpos.x+zhy.mesh.position.x,zhy.pb.position.y+newpos.y+zhy.mesh.position.y,zhy.pb.position.z+newpos.z+zhy.mesh.position.z);
            v0 = new BABYLON.Vector3(this.Probe[31].position.x,this.Probe[31].position.y+5,this.Probe[31].position.z)
            let tempvec2 = new BABYLON.Vector3(v2.x,v2.y+0.5,v2.z);
            let myPoints2=[v0,tempvec2,v2];
            let line2=BABYLON.MeshBuilder.CreateLines("line2", {points: myPoints2}, this.scene); 
            line2.color=BABYLON.Color3.Black(); 
        }
        

        //GUI
        // this.guiManger.createLabel(dfy.plus,"30px","30px");
        // this.guiManger.createLabel(dfy.minus,"30px","30px");
        // this.guiManger.createLabel(dfy.plusA,"30px","30px");
        // this.guiManger.createLabel(dfy.plusB,"30px","30px");
        // this.guiManger.createLabel(dfy.plusM,"30px","30px");
        // this.guiManger.createLabel(dfy.plusN,"30px","30px");
        // this.guiManger.createLabel(battery.plus,"30px","30px");
        // this.guiManger.createLabel(battery.minus,"30px","30px");
        // this.guiManger.createLabel(zhy.plusA,"30px","30px");
        // this.guiManger.createLabel(zhy.plusB,"30px","30px");
        // this.guiManger.createLabel(zhy.plusM,"30px","30px");
        // this.guiManger.createLabel(zhy.plusN,"30px","30px");

        //eleall
        dfy.eleall = [dfy.plusA,dfy.plusB,dfy.plusM,dfy.plusN,zhy.plusA,zhy.plusB,zhy.plusM,zhy.plusN,dfy.plus,dfy.minus,battery.plus,battery.minus];

    }
    matchlink(scene,eleall){
        let myPointsCal=function(startPoints,endPoints,height){
            let myPoints = [
                startPoints,
                new BABYLON.Vector3(startPoints.x, startPoints.y+height, startPoints.z),
                new BABYLON.Vector3(endPoints.x, endPoints.y+height, endPoints.z),
                endPoints,
            ];
            return myPoints;
        }
        
        let plusMesh=null;
        let myPoints=[BABYLON.Vector3.Zero(),BABYLON.Vector3.Zero()];
        let lines= null;
        let banmesh=[];
        let alllines=[];
        //line follows mouse movemonet
        let newtarget=this.guiManger.initGuiTarget("guiLine","10px","10px","black","white");
        let newline=this.guiManger.initGuiLine("guiTarget",0.5,5,"black");
        newtarget.isVisible=false;
        newline.isVisible=false;

        this.observer=this.scene.onPointerObservable.add((pointerInfo) => {
            let pickInfo = this.scene.pick(this.scene.pointerX, this.scene.pointerY);
            
            switch (pointerInfo.type) {
                case BABYLON.PointerEventTypes.POINTERDOWN:
                outer:
                if(plusMesh===null){
                    if(pickInfo.hit){
                        let j=0;
                        for(let i=0;i<eleall.length;i++){
                            //console.log(pickInfo.pickedMesh.name+i);
                            //console.log(banmesh);
                            if(banmesh.length!==0 ){
                                if(pickInfo.pickedMesh.name===banmesh[i]){
                                //console.log("checked");
                                break outer;
                                }
                            }
                            if(pickInfo.pickedMesh.name===eleall[i].name){
                                //console.log("checked2");
                                continue;
                            }
                            else{
                                j++;
                            }
                            if(j>=eleall.length){
                                //console.log("break");
                                break outer;
                            }
                        }
                        //console.log(pickInfo.pickedMesh.name);
                        plusMesh=pickInfo.pickedMesh;
                        myPoints=[plusMesh.position,plusMesh.position];

                        newtarget.isVisible=true;
                        newline.isVisible=true;
                        newtarget.linkWithMesh(pickInfo.pickedMesh);
                        newline.connectedControl = newtarget;
                    }
                }
                else{
                    if(pickInfo.hit){
                        //console.log(pickInfo.pickedMesh.name);
                        if(pickInfo.pickedMesh!==plusMesh && pickInfo.pickedMesh.name===plusMesh.name){
                            //console.log(true);
                            //lines.dispose();
                            banmesh.push(plusMesh.name);
                            let temp=pickInfo.pickedMesh;
                            banmesh.push(temp.name);
                            let vec=plusMesh.getBoundingInfo().boundingBox.centerWorld;
                            let vec2=pickInfo.pickedMesh.getBoundingInfo().boundingBox.centerWorld;
                            //myPoints=[vec,vec2];
                            myPoints=myPointsCal(vec,vec2,1.0);
                            let line=BABYLON.MeshBuilder.CreateLines("line", {points: myPoints}, scene);
                            line.color=BABYLON.Color3.Black(); 
                            alllines.push(line);
                            plusMesh=null;
                            myPoints=[BABYLON.Vector3.Zero(),BABYLON.Vector3.Zero()];

                            newtarget.isVisible=false;
                            newline.isVisible=false;
                            //console.log(banmesh);
                            break;
                        }
                    }
                }
                    
                    //console.log("POINTER DOWN");
                    break;
                
                case BABYLON.PointerEventTypes.POINTERMOVE:
                    if(plusMesh===null){
                        break;
                    } 
                    newline.x1=this.scene.pointerX;
                    newline.y1=this.scene.pointerY;
                    //console.log("POINTER MOVE");
                    break;
            }
        });
    }
    alphaAnimation2(data){
        if(this.colorSpheres.length!=0){
            this.colorSpheres.forEach(item=>{
                item.dispose();
            });
            this.colorSpheres=[];
        }
        let colorSpheres=[];
        let colorSphere = BABYLON.Mesh.CreatePlane("colorSphere", 10, this.scene);
        colorSphere.alwaysSelectAsActiveMesh = true;
        colorSphere.isVisible=false;
        colorSphere.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        //console.log(data.xpos.length);
        let j= 0;
        for(let i=0;i<data.xpos.length;i++){
            let colorSphereIns = colorSphere.createInstance("colorSphere"+i);
            //let colorSphereIns = BABYLON.Mesh.CreatePlane("colorSphere", 10, this.scene);
            //colorSphereIns.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
            if(j===this.Probe.length){
                j=0;
            }
            colorSphereIns.position.z=-data.xpos[i]+this.Probe[0].position.z;
            colorSphereIns.position.y=-data.ypos[i]+this.Probe[0].position.y;
            colorSphereIns.position.x=this.Probe[0].position.x;
            j++;

            // let csmat = new BABYLON.StandardMaterial("colorSphere"+i,this.scene);
            // csmat.emissiveColor = new BABYLON.Color3(data.cor[i].r/255,data.cor[i].g/255,data.cor[i].b/255);
            // colorSphereIns.material = csmat;
            //colorSphereIns.parent = colorSphere;
            colorSpheres.push(colorSphereIns);
        }
        this.colorSpheres=colorSpheres;

        let colorData = new Float32Array(4 * data.cor.length);

        for (let index = 0; index < data.cor.length; index++) {
            colorData[index * 4] = data.cor[index].r/255;
            colorData[index * 4 + 1] = data.cor[index].g/255;
            colorData[index * 4 + 2] = data.cor[index].b/255;
            colorData[index * 4 + 3] = 1.0;
        }

        let buffer = new BABYLON.VertexBuffer(this.engine, colorData, BABYLON.VertexBuffer.ColorKind, false, false, 4, true);
        //colorSphere.computeWorldMatrix();
        colorSphere.setVerticesBuffer(buffer);
        // for(let i=0;i<data.cor.length/3-1;i++){
        //     let csmat = new BABYLON.StandardMaterial("colorSphere"+i,this.scene);
        //     csmat.emissiveColor = new BABYLON.Color3(data.cor[3*i]/255,data.cor[3*i+1]/255,data.cor[3*i+2]/255);
        //     this.colorSpheres[i].material = csmat;
        // }
    }
    Schlumberger(spheregen, disOfProbe, data){

        let colorSphere = BABYLON.Mesh.CreatePlane("colorSphere", 10, this.scene);
        colorSphere.alwaysSelectAsActiveMesh = true;
        colorSphere.isVisible=false;
        colorSphere.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        let colorSpheres = [];

        let layerCount = (spheregen.length - 2) / 2;
        layerCount = parseInt(layerCount);
        //console.log(layerCount);
        let k = 0;
        for(let i = 0; i<layerCount; i++){
            for(let j = 0; j<spheregen.length-1-2*(i+1);j++){
                if(k >= data.cor.length){
                    break;
                }
                let newpos = BABYLON.Vector3.Lerp(spheregen[j].position, spheregen[j + (3 + 2 * i)].position, 0.5);
                let height = BABYLON.Vector3.Lerp(spheregen[j + (i+1)].position, spheregen[j + (i+1) + 1].position, 0.5);
                newpos.y = height.y - (i + 1) * disOfProbe;

                let colorSphereIns = colorSphere.createInstance("colorSphere"+k);
                colorSphereIns.position = newpos;
                colorSpheres.push(newpos);

                //Animation position
                let pl = [];
                let apos = new BABYLON.Vector3(spheregen[j].position.x,spheregen[j].position.y+disOfProbe,spheregen[j].position.z);
                let mpos = new BABYLON.Vector3(spheregen[j + (i+1)].position.x,spheregen[j + (i+1)].position.y+disOfProbe,spheregen[j + (i+1)].position.z);
                let npos = new BABYLON.Vector3(spheregen[j + (i+1) + 1].position.x,spheregen[j + (i+1) + 1].position.y+disOfProbe,spheregen[j + (i+1) + 1].position.z);
                let bpos = new BABYLON.Vector3(spheregen[j + (3 + 2 * i)].position.x,spheregen[j + (3 + 2 * i)].position.y+disOfProbe,spheregen[j + (3 + 2 * i)].position.z);
                
                pl.push(apos)   //A
                pl.push(mpos)   //M
                pl.push(npos)   //N
                pl.push(bpos)   //B

                this.probeArrayPos.push(pl);

                k++;
            }
        }

        this.colorSpheres = colorSpheres;

        let colorData = new Float32Array(4 * data.cor.length);

        for (let index = 0; index < data.cor.length; index++) {
            colorData[index * 4] = data.cor[index].r/255;
            colorData[index * 4 + 1] = data.cor[index].g/255;
            colorData[index * 4 + 2] = data.cor[index].b/255;
            colorData[index * 4 + 3] = 1.0;
        }

        let buffer = new BABYLON.VertexBuffer(this.engine, colorData, BABYLON.VertexBuffer.ColorKind, false, false, 4, true);
        //colorSphere.computeWorldMatrix();
        colorSphere.setVerticesBuffer(buffer);

        colorSphere.material = new BABYLON.StandardMaterial("material");
        colorSphere.material.disableLighting = true;
        colorSphere.material.emissiveColor = BABYLON.Color3.White();
    }
    createAnimation(){
        let SphereSize = 10;
        let blackcube = BABYLON.Mesh.CreateBox("blackcube", SphereSize, this.scene);
        let blackcubes = [];
        let bcmat = new BABYLON.StandardMaterial("bcMat", this.scene);
        bcmat.disableLighting = true;
        bcmat.emissiveColor = BABYLON.Color3.Gray();
        //bcmat.backFaceCulling = false;
        blackcube.material = bcmat;
        for(let i = 0; i <this.colorSpheres.length; i++){
            let blackcubeIns = blackcube.createInstance("blackcube"+i);
            blackcubeIns.position = this.colorSpheres[i];
            blackcubes.push(blackcubeIns);
        }

        let Aplane = BABYLON.Mesh.CreatePlane("Aplane", 100, this.scene);
        let Bplane = BABYLON.Mesh.CreatePlane("Bplane", 100, this.scene);
        let Mplane = BABYLON.Mesh.CreatePlane("Mplane", 100, this.scene);
        let Nplane = BABYLON.Mesh.CreatePlane("Nplane", 100, this.scene);

        let lightA=BABYLON.Mesh.CreatePlane("lightA", 1, this.scene);
        lightA.scaling = new BABYLON.Vector3(2,20,2);
        lightA.parent = Aplane;

        let lightM=BABYLON.Mesh.CreatePlane("lightM", 1, this.scene);
        lightM.scaling = new BABYLON.Vector3(2,20,2);
        lightM.parent = Mplane;

        let lightN=BABYLON.Mesh.CreatePlane("lightN", 1, this.scene);
        lightN.scaling = new BABYLON.Vector3(2,20,2);
        lightN.parent = Nplane;

        let lightB=BABYLON.Mesh.CreatePlane("lightB", 1, this.scene);
        lightB.scaling = new BABYLON.Vector3(2,20,2);
        lightB.parent = Bplane;

        let lightmat = new BABYLON.StandardMaterial("lightmat", this.scene);
        lightmat.disableLighting = true;
        lightmat.emissiveColor = BABYLON.Color3.Blue();

        lightA.material = lightmat;
        lightM.material = lightmat;
        lightN.material = lightmat;
        lightB.material = lightmat;

        this.guiManger.createLabelAtPlane(Aplane, "A", "100px");
        this.guiManger.createLabelAtPlane(Bplane, "B", "100px");
        this.guiManger.createLabelAtPlane(Mplane, "M", "100px");
        this.guiManger.createLabelAtPlane(Nplane, "N", "100px");

        Aplane.position = this.probeArrayPos[0][0];
        Bplane.position = this.probeArrayPos[0][3];
        Mplane.position = this.probeArrayPos[0][1];
        Nplane.position = this.probeArrayPos[0][2];

        lightA.position.y-=15;
        lightB.position.y-=15;
        lightM.position.y-=15;
        lightN.position.y-=15;

        Aplane.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        Bplane.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        Mplane.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        Nplane.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;

        let moveBox = BABYLON.Mesh.CreateBox("moveBox", SphereSize, this.scene);
        let moveBoxMat = new BABYLON.StandardMaterial("moveBox", this.scene);
        moveBoxMat.disableLighting = true;
        moveBoxMat.emissiveColor = BABYLON.Color3.Black();
        moveBox.material = moveBoxMat;
        let frameRate = 10;

        moveBox.scaling = new BABYLON.Vector3(1.1,1.1,1.1);

        let littleMoveBox = BABYLON.Mesh.CreateBox("littleMoveBox", 0.5, this.scene);
        littleMoveBox.parent = moveBox;

        let animationBox = new BABYLON.Animation("moveBoxAnimation", "position", 30, BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
            BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);
        let boxKeys = [];
        for (let i = 0; i < this.colorSpheres.length-1; i++) {
            boxKeys.push({
                frame: i,
                value: this.colorSpheres[i]
            });
            boxKeys.push({
                frame: (i + 1) * frameRate,
                value: this.colorSpheres[i + 1]
            });
        }
        animationBox.setKeys(boxKeys);
        moveBox.animations.push(animationBox);
        //---------------------//
        let moveboxlength = frameRate * (this.colorSpheres.length);
        //--------------------//
        for(let i =0;i<blackcubes.length;i++){
            blackcubes[i].actionManager = new BABYLON.ActionManager(this.scene);
            blackcubes[i].actionManager.registerAction(
               new BABYLON.SetValueAction(
                   {
                       trigger: BABYLON.ActionManager.OnIntersectionEnterTrigger,
                       usePreciseIntersection: true,
                       parameter: littleMoveBox
                       //parameter: moveBox
                   },
                   blackcubes[i],
                   'isVisible',
                   false
               )
            )
            .then(
                new BABYLON.SetValueAction(
                    {
                        trigger: BABYLON.ActionManager.OnIntersectionExitTrigger,
                        usePreciseIntersection: true,
                        //parameter: littleMoveBox
                        parameter: moveBox
                    },
                    blackcubes[i],
                    'isVisible',
                    false
                )
            );
        }

        //probe Animations
        let al = this.planeAnimations(Aplane, frameRate, this.probeArrayPos, 0);
        let ml = this.planeAnimations(Mplane, frameRate, this.probeArrayPos, 1);
        let nl = this.planeAnimations(Nplane, frameRate, this.probeArrayPos, 2);
        let bl = this.planeAnimations(Bplane, frameRate, this.probeArrayPos, 3);

        this.guiManger.initAnimationCtrlPanel([Aplane, Bplane, Mplane, Nplane, moveBox], [al, bl, ml, nl, moveboxlength]);
    }
    cameraFoucs(disOfProbe){
        let vec1 = this.endpoint.subtract(this.startpoint);
        let vec2 = this.endpoint.subtract(this.colorSpheres[this.colorSpheres.length-1]);
        let cross = BABYLON.Vector3.Cross(vec1, vec2);
        cross = BABYLON.Vector3.Normalize(cross);
        //let freecamera = new BABYLON.FreeCamera("freecamera", new BABYLON.Vector3(0, 0, 0), this.scene);
        let arrow = BABYLON.MeshBuilder.CreateBox("arrow", {size: 0.1}, this.scene);
        let t1 = BABYLON.Vector3.Lerp(this.startpoint,this.endpoint,0.5);
        let t2 = new BABYLON.Vector3(t1.x,t1.y-((this.Probe.length-2)/4 * disOfProbe),t1.z);
        
        let newpos = new BABYLON.Vector3(t2.x,t2.y,t2.z);
        arrow.position = newpos;
        arrow.translate(cross,-this.distance*1.01);
        this.camera.position = arrow.position;
        this.camera.target = t2;
        arrow.isVisible = false;
        this.camera.attachControl(this.canvas, true); 
        //this.camera.detachControl();
        //this.camera.fov = 0.35;
        
        //this.scene.activeCamera = freecamera;
    }

    alphaAnimation(spheregen, disOfProbe, colorvalues){
        // if(this.colorSpheres.length!=0){
        //     this.colorSpheres.forEach(item=>{
        //         item.dispose();
        //     });
        //     this.colorSpheres=[];
        // }
        let dispalyProbe = [];
        //console.log("distance of peobe: "+disOfProbe);
        let pointLocation = [];
        let planeLocation = [];
        for(let j=0;j<Math.trunc((spheregen.length-1)/3);j++){
            this.testDeep=j;
            for(let i=0;i<spheregen.length-(3*(j+1));i++){
                let newPos = BABYLON.Vector3.Lerp(spheregen[i].position, spheregen[i + 3 * (j + 1)].position, 0.5);
                //let x1 = new BABYLON.Vector3(spheregen[i].position.x, spheregen[i].position.y, spheregen[i].position.z);
                //let x2 = new BABYLON.Vector3(spheregen[i + 3 * (j + 1)].position.x, spheregen[i + 3 * (j + 1)].position.y, spheregen[i + 3 * (j + 1)].position.z);
                dispalyProbe.push(i);
                dispalyProbe.push(i + 3 * (j + 1));
                //newPos.y -= (j + 1) * disOfProbe;
                newPos.y = spheregen[parseInt((i+(i + 3 * (j + 1)))/2)].position.y - (j + 1) * disOfProbe ;
                pointLocation.push(newPos);


                let pl = [];
                pl.push(new BABYLON.Vector3(spheregen[i].position.x, spheregen[i].position.y+10, spheregen[i].position.z));
                let step = 1 / 3;
                // for (let k = step; k < 1; k += step) {
                //     let np = BABYLON.Vector3.Lerp(spheregen[i].position, spheregen[i + 3 * (j + 1)].position, k);
                //     np.y += 10;
                //     pl.push(np);
                // }
                // pl.push(new BABYLON.Vector3(spheregen[i + 3 * (j + 1)].position.x, spheregen[i + 3 * (j + 1)].position.y+10, spheregen[i + 3 * (j + 1)].position.z));
                
                for (let k = step; k < 1; k += step) {
                    let np = BABYLON.Vector3.Lerp(spheregen[i].position, spheregen[i + 3 * (j + 1)].position, k);
                    np.y += 10;
                    pl.push(np);
                }
                pl.push(new BABYLON.Vector3(spheregen[i + 3 * (j + 1)].position.x, spheregen[i + 3 * (j + 1)].position.y+10, spheregen[i + 3 * (j + 1)].position.z));

                planeLocation.push(pl);
            }
        }
        // console.log("pointLocation done!length: " + pointLocation.length);
        // console.log(this.testDeep);
        let SphereSize = 0;
        if (disOfProbe <= 5) {
            SphereSize = 5;
        }
        else {
            SphereSize = 10;
        }
        //console.log(pointLocation)
        let colorSpheres=[];
        let colorSphere = BABYLON.Mesh.CreatePlane("colorSphere", SphereSize, this.scene);
        colorSphere.alwaysSelectAsActiveMesh = true;
        colorSphere.isVisible=false;
        colorSphere.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        // let mat = new BABYLON.StandardMaterial("dog", this.scene);
        // mat.diffuseColor=new BABYLON.Color3(1, 1, 1);
        //mat.backFaceCulling = false;
        //mat.freeze();
        //colorSphere.material = mat;
        
        colorSpheres.push(colorSphere);
        this.scene.blockfreeActiveMeshesAndRenderingGroups = true;
        let looplength=1000;
        if(pointLocation.length>10000){
            looplength=10000;
        }
        else{
            looplength=pointLocation.length;
        }
        //let mats = [];
        //mats.push(mat);
        let blackcube = BABYLON.Mesh.CreateBox("blackcube", SphereSize, this.scene);
        let blackcubes = [];
        let bcmat = new BABYLON.StandardMaterial("bcMat", this.scene);
        bcmat.disableLighting = true;
        bcmat.emissiveColor = BABYLON.Color3.Gray();
        //bcmat.backFaceCulling = false;
        blackcube.material = bcmat;
        for (let i = 0; i < looplength;i++){
            
            let colorSphereIns = colorSphere.createInstance("colorSphere"+i);
            colorSphereIns.position=pointLocation[i];

            let blackcubeIns = blackcube.createInstance("blackcube"+i);
            blackcubeIns.position = pointLocation[i];
            // let mat =  new BABYLON.StandardMaterial("dog", this.scene);
            // mat.diffuseColor=new BABYLON.Color3(1, 1, 1);
            // colorSphereIns.material = mat;
            // mats.push(mat);
            //colorSphereIns.freezeWorldMatrix();
            //colorSphereIns.doNotSyncBoundingInfo = true;
            //colorSphereIns.isVisible = false;
            colorSpheres.push(colorSphereIns);

            blackcubes.push(blackcubeIns);

            //dubug
            //blackcubeIns.isVisible = false;
            
        }
        //this.scene.blockfreeActiveMeshesAndRenderingGroups = false;
        //this.colorSpheres=colorSpheres;
        
        let colorData = new Float32Array(4 * colorvalues.length);
        // console.log(colorvalues.length);
        // console.log(looplength);
        for (let index = 0; index <  colorvalues.length; index++) {
            colorData[index * 4] = colorvalues[index].r/255;
            colorData[index * 4 + 1] = colorvalues[index].g / 255;
            colorData[index * 4 + 2] = colorvalues[index].b / 255;
            colorData[index * 4 + 3] = 1.0;
        }

        let buffer = new BABYLON.VertexBuffer(this.engine, colorData, BABYLON.VertexBuffer.ColorKind, false, false, 4, true);
        colorSphere.setVerticesBuffer(buffer);
        // let mat = new BABYLON.StandardMaterial("dog", this.scene);
        // mat.disableLighting = true;
        // mat.emissiveColor = BABYLON.Color3.White();
        // mat.backFaceCulling = false;
        // colorSphere.material = mat;

        //let colorProbes = [];
        //for (let i = 0; i < spheregen.length; i++) {
        //    let materialBox = new BABYLON.StandardMaterial("" + i, this.scene);
        //    materialBox.diffuseColor = new BABYLON.Color3(0.55, 0.55, 0.55);//Green
            
        //    let colorProbe = BABYLON.Mesh.CreateBox("colorProbe" + i, { width: 50, height: 100, depth: 50 }, this.scene);
        //    colorProbe.material = materialBox;
        //    let x = new BABYLON.Vector3(spheregen[i].position.x, spheregen[i].position.y, spheregen[i].position.z);
        //    colorProbe.position = x;
        //    //colorProbe.isVisible = false;
        //    colorProbes.push(colorProbe);

        //}

        let Aplane = BABYLON.Mesh.CreatePlane("Aplane", 100, this.scene);
        let Bplane = BABYLON.Mesh.CreatePlane("Bplane", 100, this.scene);
        let Mplane = BABYLON.Mesh.CreatePlane("Mplane", 100, this.scene);
        let Nplane = BABYLON.Mesh.CreatePlane("Nplane", 100, this.scene);
        this.guiManger.createLabelAtPlane(Aplane, "A", "100px");
        this.guiManger.createLabelAtPlane(Bplane, "B", "100px");
        this.guiManger.createLabelAtPlane(Mplane, "M", "100px");
        this.guiManger.createLabelAtPlane(Nplane, "N", "100px");

        //let newposa = new BABYLON.Vector3(spheregen[0].position.x, spheregen[0].position.y, spheregen[0].position.z);
        //let newposm = new BABYLON.Vector3(spheregen[1].position.x, spheregen[1].position.y, spheregen[1].position.z);
        //let newposn = new BABYLON.Vector3(spheregen[2].position.x, spheregen[2].position.y, spheregen[2].position.z);
        //let newposb = new BABYLON.Vector3(spheregen[3].position.x, spheregen[3].position.y, spheregen[3].position.z);

        Aplane.position = planeLocation[0][0];
        Bplane.position = planeLocation[0][3];
        Mplane.position = planeLocation[0][1];
        Nplane.position = planeLocation[0][2];

        Aplane.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        Bplane.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        Mplane.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        Nplane.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        //Bplane.parent = Aplane;
        //Mplane.parent = Aplane;
        //Nplane.parent = Aplane;

        //Aplane.position.y += SphereSize;
        //Bplane.position.y += SphereSize;
        //Mplane.position.y += SphereSize;
        //Nplane.position.y += SphereSize;
        let moveBox = BABYLON.Mesh.CreateBox("moveBox", SphereSize, this.scene);
        let moveBoxMat = new BABYLON.StandardMaterial("moveBox", this.scene);
        moveBoxMat.disableLighting = true;
        moveBoxMat.emissiveColor = BABYLON.Color3.Black();
        moveBox.material = moveBoxMat;
         let frameRate = 10;
         let animationsClip=[];
        moveBox.scaling = new BABYLON.Vector3(1.1,1.1,1.1);

        let littleMoveBox = BABYLON.Mesh.CreateBox("littleMoveBox", 0.5, this.scene);
        littleMoveBox.parent = moveBox;
         //for(let i=0;i<colorSpheres.length;i++){
         //    //let materialBox = new BABYLON.StandardMaterial(""+i,this.scene);
         //    //materialBox.diffuseColor = new BABYLON.Color3(0.55, 0.55, 0.55);//Green
         //    //colorSpheres[i].material = materialBox;
         //    let rx = colorSpheres[i].rotation.x;
         //    let animationBox = new BABYLON.Animation("tutoAnimation" + i, "rotation.y", frameRate, BABYLON.Animation.ANIMATIONTYPE_FLOAT,
         //        BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);
         //    let keys = [];
         //    keys.push({
         //        frame: 0,
         //        value: rx
         //    });
         //    keys.push({
         //        frame: (i) * frameRate,
         //        value: Math.PI
         //    });
         //    keys.push({
         //        frame: (i+5)*frameRate,
         //        value: rx
         //    });
         //    //console.log(keys);
         //    animationBox.setKeys(keys);
         //    animationsClip.push(animationBox);
          
         //    this.scene.beginDirectAnimation(colorSpheres[i], [animationBox], 0, (20) * frameRate * (i + 1), false);
         //}
        let animationBox = new BABYLON.Animation("moveBoxAnimation", "position", 30, BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
            BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);
        let boxKeys = [];
        for (let i = 0; i < pointLocation.length-1; i++) {
            boxKeys.push({
                frame: i,
                value: pointLocation[i]
            });
            boxKeys.push({
                frame: (i + 1) * frameRate,
                value: pointLocation[i + 1]
            });
        }
        animationBox.setKeys(boxKeys);
        moveBox.animations.push(animationBox);
        let moveboxlength = frameRate * (pointLocation.length);
        //animationsClip.push(animationBox);
        //this.scene.beginDirectAnimation(moveBox, [animationBox], 0, frameRate * (i + 1), false);
        //let moveboxlength = frameRate * (i + 1);
        for(let i =0;i<blackcubes.length;i++){
            blackcubes[i].actionManager = new BABYLON.ActionManager(this.scene);
            blackcubes[i].actionManager.registerAction(
               new BABYLON.SetValueAction(
                   {
                       trigger: BABYLON.ActionManager.OnIntersectionEnterTrigger,
                       parameter: littleMoveBox
                   },
                   blackcubes[i],
                   'isVisible',
                   false
               )
           );
        }

        //probe Animations
        let al = this.planeAnimations(Aplane, frameRate, planeLocation, 0);
        let ml = this.planeAnimations(Mplane, frameRate, planeLocation, 1);
        let nl = this.planeAnimations(Nplane, frameRate, planeLocation, 2);
        let bl = this.planeAnimations(Bplane, frameRate, planeLocation, 3);

        let target = BABYLON.Vector3.Lerp(spheregen[0].position,spheregen[spheregen.length-1].position,0.5);
        target.y-=disOfProbe;

        let vec1 = spheregen[0].position.subtract(spheregen[spheregen.length-1].position);
        let vec2 = spheregen[0].position.subtract(colorSpheres[colorSpheres.length-1].position);
        let direction=BABYLON.Vector3.Zero();;
        BABYLON.Vector3.CrossToRef(vec1,vec2,direction);
        direction = BABYLON.Vector3.Normalize(direction);
        direction = direction.multiplyByFloats(5,5,5);
        let pivot = BABYLON.MeshBuilder.CreateBox("pivot",{size:1},this.scene);
        //cube.setDirection(direction);
        pivot.position = target;
        pivot.translate(direction, 100);
        this.camera.target = spheregen[Math.trunc(spheregen.length / 2)].position;
        
        let vec3 = this.camera.getDirection(BABYLON.Vector3.Up());
        let angel = BABYLON.Vector3.Dot(direction, vec3);

        angel /= (Math.abs(direction.length()) * Math.abs(vec3.length()));
        angel = angel.toFixed(2);
        //console.log("angles: " + angel);
        // let np1 = new BABYLON.Vector3(pivot.position.x, pivot.position.y, pivot.position.z);
        // let np2 = new BABYLON.Vector3(planeLocation[0][0].x, planeLocation[0][0].y, planeLocation[0][0].z);
        //this.myCameraAinmation(np1, np1, 200, angel,false);
        pivot.isVisible = false;
        // pivot.dispose();
        //alert("请点击>按钮播放动画");
        this.guiManger.initAnimationCtrlPanel([Aplane, Bplane, Mplane, Nplane, moveBox], [al, bl, ml, nl, moveboxlength]);
    }
    planeAnimations(mesh, frameRate, planeLocation, id) {
        let animationBox = new BABYLON.Animation("tutoAnimation", "position", 30, BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
            BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);

        let keys = [];
        for (let i = 0; i < planeLocation.length - 1; i++) {
            // Animation keys

            keys.push({
                frame: i,
                value: planeLocation[i][id]
            });

            //keysA.push({
            //    frame: i * frameRate,
            //    value: planeLocation[i][0]
            //});
            keys.push({
                frame: (i + 1) * frameRate,
                value: planeLocation[i + 1][id]
            });


        }

        animationBox.setKeys(keys);
        mesh.animations.push(animationBox);

        //this.scene.beginAnimation(mesh, 0, frameRate * (i + 1), true);
        return frameRate * (planeLocation.length);
    }
    popupPassValue(probes,colorspheres,disOfProbe,color){
        let popup = window.open(SecondURL+'/index2.html','','top=100,left=100,width=300,height=200');
        if(popup != null && !popup.closed){
            window.windowPool = []; 
            let params = {
                "probes":probes,
                "colorspheres":colorspheres,
                "disOfProbe":disOfProbe,
                "color":color,
                "probeArrayPos":this.probeArrayPos

            };
            window.windowPool.push({
                "window": popup,
                "parameter": params
              });
        }
        else{
            alert("请允许弹窗，允许后重试.");
        }
    }
    axiosColor(spheregen, disOfProbe, geosize,distance,geoId) {
        this.engine.displayLoadingUI();
        this.testDeep=Math.trunc((spheregen.length-1)/3);
        let nx=0,nz=0,ny=0;
        let half = 50;
        half=geoId===1?50:75;
        // if(this.startpoint.x<0){
        //     nx = (this.startpoint.x/20) - half;
        // }
        // else{
        //     nx = half - (this.startpoint.x/20);
        // }
        // if(this.startpoint.z<0){
        //     ny = (this.startpoint.z/20) - half;
        // }
        // else{
        //     ny = half - (this.startpoint.z/20);
        // }
        nx = (this.startpoint.x-this.endpoint.x)/150;
        ny = (this.startpoint.z-this.endpoint.z)/150;
        nz = this.testDeep;
       let jx = parseInt(Math.abs(nx));
       let jy = parseInt(Math.abs(ny));
       let allProbes=[];
       for(let i=0;i<this.Probe.length;i++){
           allProbes.push(this.Probe[i].position.x);
           allProbes.push(this.Probe[i].position.y);
           allProbes.push(this.Probe[i].position.z);
       }
       this.id = uuidv4();
        /*
        const validateMermRequest = (payload) => {
            const errors = [];

            if (payload.start && payload.start[2] < 0) {
                errors.push(`起点Z坐标为负数 (${payload.start[2].toFixed(2)})，超出模型范围`);
            }

            if (payload.end && payload.end[2] < 0) {
                errors.push(`终点Z坐标为负数 (${payload.end[2].toFixed(2)})，超出模型范围`);
            }


            if (payload.allProbes) {
                for (let i = 0; i < payload.allProbes.length; i += 3) {
                    const x = payload.allProbes[i];
                    const y = payload.allProbes[i + 1];
                    const z = payload.allProbes[i + 2];
                    if (x < 0 || y < 0 || z < 0) {
                        errors.push(`电极 ${Math.floor(i/3) + 1} 坐标 (${x.toFixed(1)}, ${y.toFixed(1)}, ${z.toFixed(1)}) 包含负值`);
                    }
                }
            }

            return {
                valid: errors.length === 0,
                errors: errors
            };
        };
        */

        let gridModel={
            playerId:this.id,   //用户ID
            nx:jx,  //网格号
            ny:jy,
            nz:nz,
            allProbes:allProbes,  //电极数据
            countOfProbe:Math.trunc(distance/disOfProbe),  //电极数量
            geoId:geoId,  //地电模型ID
            start:[  //起点电极定位坐标
                this.startpoint.x,
                this.startpoint.y,
                this.startpoint.z
            ],
            end:[  //终点电极定位坐标
                this.endpoint.x,
                this.endpoint.y,
                this.endpoint.z
            ],
            step:this.probeDistance,  //测线长度
            testDeep:this.testDeep,  //剖面深度
            femSolver:"R2"  //有限元求解器选型
        };
        /*
        const validation = validateMermRequest(gridModel);
        if (!validation.valid) {
            alert(`请求参数无效:\n${validation.errors.join('\n')}`);
            this.engine.hideLoadingUI();
            // window.location.reload();
            return;
        }
        */
        //console.log(gridModel);
        //POST方法
        axios.post(URL+'/api/Merm',  //POST方法请求地址
            gridModel
        )
            .then((response) => {//服务器返回计算结果
                const { code, message } = response.data || {};
                if (code && code !== 201) {
                    this.engine.hideLoadingUI();
                    alert(`服务器返回错误: ${message || '未知错误'}\n(如提示电极/深度不足或坐标越界，请调整后再试)`);
                    return;
                }

                let colors = response.data.cor; //视电阻率颜色
                const { imageUrl } = response.data || {};
                if (imageUrl && typeof this.onResultImage === 'function') {
                    this.onResultImage(imageUrl);
                }
                //console.log(response.data);
                this.engine.hideLoadingUI();
               //this.alphaAnimation(spheregen, disOfProbe, colors);
                //this.alphaAnimation2(response.data);
                //施伦贝尔装置方法
                this.Schlumberger(spheregen, disOfProbe, response.data);
                 //创建跑极动画 
                this.createAnimation();
                this.camera.lowerRadiusLimit = 20;
                this.cameraFoucs(disOfProbe);
                //实现视电阻率场分布显示
                this.popupPassValue(spheregen,this.colorSpheres,disOfProbe,colors);
                //console.log(colors[0].r);
            }).catch((error) => {
                //console.log(error);
                if (error.response && error.response.status === 500) {
                    alert("测量计算失败。\n\n原因：测线未经过高阻体区域（内部实体）。\n\n请尝试调整测线位置，使其穿过或位于高阻体上方，目前不支持在纯填充区域进行测量。");
                    // window.location.reload();
                } else {
                    alert("测量计算失败。\n\n可能原因：测线未经过高阻体区域（移动摄像机可见的内部实体）。\n\n请尝试调整测线位置，使其穿过或位于高阻体上方。"+error);
                    // window.location.reload();
                }
            });
    }
    //弃用
    showAxis(size,scene,pos) {
        let makeTextPlane = function(text, color, size) {
        let dynamicTexture = new BABYLON.DynamicTexture("DynamicTexture", 50, scene, true);
        dynamicTexture.hasAlpha = true;
        dynamicTexture.drawText(text, 5, 40, "bold 36px Arial", color , "transparent", true);
        let plane = new BABYLON.Mesh.CreatePlane("TextPlane", size, scene, true);
        plane.material = new BABYLON.StandardMaterial("TextPlaneMaterial", scene);
        plane.material.backFaceCulling = false;
        plane.material.specularColor = new BABYLON.Color3(0, 0, 0);
        plane.material.diffuseTexture = dynamicTexture;
        return plane;
         };
      
         let Axis = BABYLON.Mesh.CreateBox("skyBox", 1, this.scene);
        let axisX = BABYLON.Mesh.CreateLines("axisX", [ 
          new BABYLON.Vector3.Zero(), new BABYLON.Vector3(size, 0, 0), new BABYLON.Vector3(size * 0.95, 0.05 * size, 0), 
          new BABYLON.Vector3(size, 0, 0), new BABYLON.Vector3(size * 0.95, -0.05 * size, 0)
          ], scene);
        axisX.color = new BABYLON.Color3(1, 0, 0);
        let xChar = makeTextPlane("X", "red", size / 10);
        xChar.position = new BABYLON.Vector3(0.9 * size, -0.05 * size, 0);
        let axisY = BABYLON.Mesh.CreateLines("axisY", [
            new BABYLON.Vector3.Zero(), new BABYLON.Vector3(0, size, 0), new BABYLON.Vector3( -0.05 * size, size * 0.95, 0), 
            new BABYLON.Vector3(0, size, 0), new BABYLON.Vector3( 0.05 * size, size * 0.95, 0)
            ], scene);
        axisY.color = new BABYLON.Color3(0, 1, 0);
        let yChar = makeTextPlane("Y", "green", size / 10);
        yChar.position = new BABYLON.Vector3(0, 0.9 * size, -0.05 * size);
        let axisZ = BABYLON.Mesh.CreateLines("axisZ", [
            new BABYLON.Vector3.Zero(), new BABYLON.Vector3(0, 0, size), new BABYLON.Vector3( 0 , -0.05 * size, size * 0.95),
            new BABYLON.Vector3(0, 0, size), new BABYLON.Vector3( 0, 0.05 * size, size * 0.95)
            ], scene);
        axisZ.color = new BABYLON.Color3(0, 0, 1);
        let zChar = makeTextPlane("Z", "blue", size / 10);
        zChar.position = new BABYLON.Vector3(0, 0.05 * size, 0.9 * size);

        axisX.parent=Axis;
        axisY.parent=Axis;
        axisZ.parent=Axis;
        Axis.position = pos;
      };
}